(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cod-before-after"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ba-slider]').forEach(function(slider) {
      var wrap = slider.querySelector('[data-ba-before-wrap]');
      var handle = slider.querySelector('[data-ba-handle]');
      if (!wrap || !handle) return;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        wrap.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        handle.style.left = pct + '%';
        slider.setAttribute('aria-valuenow', Math.round(pct));
      }

      function pctFromX(clientX) {
        var rect = slider.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      // Mouse
      var mDragging = false;
      slider.addEventListener('mousedown', function(e){ mDragging = true; e.preventDefault(); setPos(pctFromX(e.clientX)); });
      window.addEventListener('mousemove', function(e){ if (mDragging) setPos(pctFromX(e.clientX)); });
      window.addEventListener('mouseup', function(){ mDragging = false; });

      // Touch: solo arrastra si el gesto es HORIZONTAL; el scroll vertical pasa de largo
      var tActive = false, decided = false, tDrag = false, sx = 0, sy = 0;
      slider.addEventListener('touchstart', function(e){
        var t = e.touches[0]; tActive = true; decided = false; tDrag = false; sx = t.clientX; sy = t.clientY;
      }, { passive: true });
      slider.addEventListener('touchmove', function(e){
        if (!tActive) return;
        var t = e.touches[0];
        if (!decided) {
          var dx = Math.abs(t.clientX - sx), dy = Math.abs(t.clientY - sy);
          if (dx < 8 && dy < 8) return;
          decided = true; tDrag = dx > dy;
        }
        if (tDrag) { e.preventDefault(); setPos(pctFromX(t.clientX)); }
      }, { passive: false });
      slider.addEventListener('touchend', function(){ tActive = false; decided = false; tDrag = false; });

      // Tap para posicionar (no interfiere con el scroll vertical)
      slider.addEventListener('click', function(e){ if (e.detail) setPos(pctFromX(e.clientX)); });

      slider.addEventListener('keydown', function(e) {
        var current = parseFloat(slider.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft')  setPos(current - 5);
        if (e.key === 'ArrowRight') setPos(current + 5);
        if (e.key === 'Home')       setPos(0);
        if (e.key === 'End')        setPos(100);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-prueba-social"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-reviews-track]').forEach(function(track){
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function carousel(){ return track.scrollWidth - track.clientWidth > 10; }
      function gap(){ var g = getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0'; return parseFloat(g) || 0; }
      function step(){ var c = track.children[0]; return c ? c.getBoundingClientRect().width + gap() : track.clientWidth; }
      function count(){ return track.children.length; }
      var idx = 0, timer = null;
      function go(i){ var n = count(); if (!n) return; idx = ((i % n) + n) % n; track.scrollTo({ left: Math.round(idx * step()), behavior: 'smooth' }); }
      function next(){ if (carousel()) go(idx + 1); }
      function play(){ if (reduce) return; stop(); timer = setInterval(next, 4500); }
      function stop(){ if (timer) { clearInterval(timer); timer = null; } }
      ['touchstart','pointerdown','wheel'].forEach(function(ev){
        track.addEventListener(ev, function(){ stop(); clearTimeout(track._r); track._r = setTimeout(play, 6000); }, { passive: true });
      });
      var s; track.addEventListener('scroll', function(){ clearTimeout(s); s = setTimeout(function(){ idx = Math.round(track.scrollLeft / step()); }, 120); }, { passive: true });
      play();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
